module.exports = __webpack_public_path__ + "static/media/siprc_dot4.257e574b.png";